module.exports = __webpack_public_path__ + "img/other-icon-img10.0c704a00.svg";